export enum MenuStatusEnum {
  ENABLED = 1,
  DISABLED = 0,
}
